import { Observable, of, catchError, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OccEndpointsService, ProductSearchPage } from '@spartacus/core';

import { CustomProductImageNormalizer } from './custom-product-image-normalizer.service';
import { ProductAccessoryTypeEnum } from '../enums/product-type.enum';

@Injectable({
  providedIn: 'root'
})
export class AccessoryCrossSellService {
  constructor(
    private customImageNormalizer: CustomProductImageNormalizer,
    private occEndpointsService: OccEndpointsService,
    private http: HttpClient
  ) {}

  private normalizeProductImages(res: ProductSearchPage): ProductSearchPage {
    if (res.products) {
      return {
        ...res,
        products: res.products.map((product) => ({
          ...product,
          images: this.customImageNormalizer.normalize((product as any).images)
        }))
      };
    }
    return res;
  }

  getAccessoriesCrossSell(code: string, pageSize: number, page: number): Observable<ProductSearchPage> {
    const url = this.occEndpointsService.buildUrl('accessoryCross', { urlParams: { code, pageSize, page } });
    return this.http.get<ProductSearchPage>(url).pipe(
      map((res: ProductSearchPage) => this.normalizeProductImages(res))
    );
  }

  getAccessoriesForProductCodes(
    codes: string[],
    page: number,
    pageSize: number,
    accessoriesType: ProductAccessoryTypeEnum
  ): Observable<ProductSearchPage> {
    const productCodes = codes.join(',');
    const url = this.occEndpointsService.buildUrl('productsAccessoriesByType', {
      queryParams: { accessoriesType, productCodes, pageSize, page }
    });
    return this.http.get<ProductSearchPage>(url).pipe(
      map((res: ProductSearchPage) => this.normalizeProductImages(res)),
      catchError(() => of(undefined))
    );
  }

  getProductAccessoriesOrderedByType(
    codes: string[],
    orderType: string,
    accessoriesType: ProductAccessoryTypeEnum,
    excludedAccessories?: string[],
    page?: number,
    pageSize?: number
  ): Observable<ProductSearchPage> {
    const productCodes = codes.join(',');
    const url = this.occEndpointsService.buildUrl('productAccessoriesOrderedByType', {
      queryParams: { productCodes, orderType, accessoriesType, excludedAccessories, page, pageSize }
    });

    return this.http.get<ProductSearchPage>(url).pipe(
      map((res: ProductSearchPage) => this.normalizeProductImages(res)),
      catchError(() => of(undefined))
    );
  }
}
